import React from "react";
import EntityForm from "../../EntityForm/EntityForm";
import axios from "http/customAxios";
import { BASE_URL } from "../../../request";

function getFields(fields, dictionaries) {
  if (dictionaries) {
    const partnersIndex = fields.form.findIndex(field => field.fieldName === "partner");
    Object.keys(dictionaries.partners).forEach(partner => {
      fields.form[partnersIndex].optionDisplay[dictionaries.partners[partner]] = { label: partner };
    });
    fields.form[partnersIndex].optionDisplay[0] = { label: "SIN PARTNER" };
  }
  return fields && fields.form && fields.form.sort((a, b) => (a.order > b.order ? 1 : -1));
}

class PropertiesForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  componentDidMount() {
    // TODO: replace with httpclient
    axios.get(`${BASE_URL}/api/crm/properties/dictionaries`).then(response => {
      if (response.status === 200 && response.data) {
        this.setState({ dictionaries: response.data });
      }
    });
  }

  handleSubmit = ({ formValues, entity }) => {
    delete formValues.translations;
    delete formValues.propertyTicker;

    this.props.onSubmitEntity({
      id: entity.id,
      entity: formValues,
    });
  };

  render() {
    const { name, validation, fields, renderers, translation, locale } = this.props.config;
    const {
      locales,
      entities,
      entity,
      entityError,
      entityResult,
      entityName,
      loading,
      getListPath,
      relatedEntities,
      updateEntity,
    } = this.props;
    const { handleSubmit } = this;

    return (
      <EntityForm
        loading={loading}
        name={name}
        entity={entity}
        entities={entities}
        validation={validation}
        renderers={renderers}
        fields={getFields(fields, this.state.dictionaries)}
        locales={locales}
        translation={translation}
        onSubmit={handleSubmit}
        entityError={entityError}
        entityResult={entityResult}
        entityName={entityName}
        getListPath={getListPath}
        relatedEntities={relatedEntities}
        locale={locale}
        updateEntity={updateEntity}
      />
    );
  }
}

PropertiesForm.propTypes = {};

PropertiesForm.defaultProps = {
  locales: ["es", "ca", "en", "fr", "it", "de"],
  getListPath: function getListPath({ hotelTicker, entityName }) {
    return `/${hotelTicker}/${entityName}/`;
  },
};

export default PropertiesForm;
